import { Component, Input, OnChanges } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { CulturalActivityMetadataByType, NonCulturalActivityType } from "@org-common/lib/cultural-activity/cultural-activity-type-metadata";
import { IActivityGroup } from "../activities-metadata";

@Component({
    selector: "adapt-personal-vision-activity-section",
    standalone: false,
    templateUrl: "./personal-vision-activity-section.component.html",
})
export class PersonalVisionActivitySectionComponent extends BaseComponent implements OnChanges {
    public readonly section = CulturalActivityMetadataByType[NonCulturalActivityType.Visions];

    @Input({ required: true }) public activityGroup!: IActivityGroup<Team>;
    @Input() public countTooltip?: string;
    @Input() public isLoading = false;
    @Input() public error?: any;
    @Input() public fallbackText?: string;

    public displayedCount = 0;
    public isIntegratedVision: { [teamId: number]: boolean } = {};

    public constructor() {
        super();
    }

    public ngOnChanges() {
        this.displayedCount = this.activityGroup.allItems.length;
    }
}
